import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Slider, Tooltip } from "@mui/material";
import { Add, Edit } from '@mui/icons-material';


import taskServices from '../taskServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';



function TaskStatusForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters,getMasterLabel} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);


    const [inputProgress,setInputProgress] = useState(data.progress);
    const [inputStatus,setInputStatus] = useState(data.status);
    const [remark,setRemark] = useState("")

    const updateStatus = () => {
        const payload ={
            id:data.id,
            projectId:data.projectId,
            progress:inputProgress,
            status:inputStatus,
            remark,remark,
        }
        taskServices.updateStatus(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const [muiColor,setMuiColor] = useState("primary")
    const [bsColor,setBsColor] = useState("primary")

    useEffect(()=>{
        if(data.status === 2){
            setMuiColor("warning")
            setBsColor("warning");
        }
        if(data.status === 3 || data.status === 4 || data.status === 5){
            setMuiColor("error")
            setBsColor("danger");
        }
        if(data.status === 6){
            setMuiColor("success")
            setBsColor("success");
        }
    },[data])

    return (
        data &&
        <>
            
            

            <div typeof='button' className='my-2'  onClick={()=>setDialogStatus(true)} >
                <LinearProgress variant="determinate" value={data.progress} style={{height:10}} className='rounded' color={muiColor} />
                <div>
                    {/* <span className="badge border border-primary rounded-pill text-primary">{data.progress}%</span> */}
                    <span className="badge bg-primary rounded-pill">{getMasterLabel('task-status',data.status)}</span>
                    <span style={{fontSize:12}} className='ms-2 text-success' >Last Update { moment(data.updated_at).fromNow()}</span>
                </div>
            </div>
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Update Status for <span className='fw-bold'> {data.title} </span></DialogTitle>
                <DialogContent>
                    <div className='row mt-2'>

                        <div className='col-md-6'>
                            <div class="form-floating mb-3">
                                <select className="form-control"
                                        onChange={(e)=> 
                                            setInputStatus(e.target.value)
                                        }
                                        value={inputStatus}
                                    >
                                        {masters['task-status'].map(status=>
                                            <option value={status.value}>{status.label}</option>
                                        )}
                                </select>
                                <label>Select Status</label>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div class="form-floating mb-3">
                                <div className='form-control'>
                                    <Slider
                                        defaultValue={inputProgress}
                                        step={5}
                                        aria-label="default"
                                        valueLabelDisplay="auto"
                                        onChange={(e, newValue)=>setInputProgress(newValue)}
                                        min={0}
                                        max={100}  
                                    />
                                </div>
                            <label>Select Progress <span className='fw-bold'>{inputProgress} %</span></label>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div class="form-floating mb-3">
                                <textarea className="form-control" onChange={(e)=> setRemark(e.target.value)} value={remark} />
                                <label>Remark</label>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            {savingInProgress ?
                                <LinearProgress/>
                                :
                                <>
                                    <button className="btn btn-primary float-end" type='button' onClick={updateStatus} >Save</button>
                                    <button className="btn btn-outline-primary" type="button" onClick={()=>setDialogStatus(false)}>Cancel</button>
                                </>
                            }
                        </div>
                    </div>
                </DialogContent>
                
            </Dialog>

        </>
    )
}

export default TaskStatusForm